import { selectIsWished, useWishlistStore } from '../../store/wishlistStore';
import './WishlistButton.css';

interface Props {
  readonly itemId: string;
  readonly name: string;
  /** Show "Wishlist"/"Wishlisted" next to the heart (product page). */
  readonly withLabel?: boolean;
  readonly className?: string;
}

/** The heart: adds the item to the wishlist, or takes it off. Works signed out too. */
export default function WishlistButton({ itemId, name, withLabel, className = '' }: Props) {
  const wished = useWishlistStore(selectIsWished(itemId));
  const toggle = useWishlistStore((s) => s.toggle);
  return (
    <button
      type="button"
      className={`wishlist-button${withLabel ? ' wishlist-button--labelled' : ''} ${className}`.trim()}
      aria-pressed={wished}
      aria-label={withLabel ? undefined : wished ? `Remove ${name} from wishlist` : `Add ${name} to wishlist`}
      onClick={() => void toggle(itemId)}
    >
      <svg
        className="wishlist-button__icon"
        viewBox="0 0 24 24"
        width="20"
        height="20"
        fill={wished ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8z" />
      </svg>
      {withLabel && <span>{wished ? 'Wishlisted' : 'Add to wishlist'}</span>}
    </button>
  );
}
